import { jsx as _jsx } from "react/jsx-runtime";
import { Help } from '@mui/icons-material';
import { Tooltip as MuiTooltip } from '@mui/material';
const Tooltip = (tooltipProps) => {
    const { children, ...props } = tooltipProps;
    return (_jsx(MuiTooltip, { enterTouchDelay: 0, arrow: true, ...props, children: children ? children : _jsx(Help, {}) }));
};
export default Tooltip;
